export default __webpack_public_path__ + "static/envelop_fly-b73462066cf298e557cadaeaec19ca2c.png";